var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { tradeoffs, property, distance, ctaText } = options; 
__p+='\n\n<h2 class="ldp-title-section">\n  <i class="ra ra-similar-homes icon-space-right"></i> Properties You Might Consider\n</h2>\n'+
((__t=( JST["quick_view/templates/consider-home/properties"]({tradeoffs, property, distance, ctaText}) ))==null?'':__t)+
'\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/consider-home/consider-homes.jst.ejs